import { apiRequest } from './client'
import type { ExternalLink } from './types'

export const linksApi = {
  list: () => apiRequest<{ data: ExternalLink[] }>('/links'),

  create: (input: { label: string; url: string; icon?: string }) =>
    apiRequest<{ data: ExternalLink }>('/links', { method: 'POST', body: input }),

  update: (id: string, input: { label?: string; url?: string; icon?: string; sortOrder?: number }) =>
    apiRequest<{ data: ExternalLink }>(`/links/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/links/${id}`, { method: 'DELETE' }),
}
